export const WIDGET_SECRET = import.meta.env.VITE_APP_WHATSAPP_WIDGET_SECRET
export const SERVER_BASE_URL = import.meta.env.VITE_APP_SERVER_BASE_URL

